module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_nordland_pos.f871160f.pdf";